import BreadcrumbLink from "features/shared/components/breadcrumbs/BreadcrumbLink";
import NavTab from "features/shared/components/navs/NavTab";
import TabsNavigation from "features/shared/components/navs/TabsNavigation";
import ModuleContent from "features/shared/layout/content/ModuleContent";
import Header from "features/shared/layout/header/Header";
import React, { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { InvoiceType } from "features/invoices/enums/invoiceType";
import { useLocation } from "react-router-dom";
import { getQueryParams } from "features/shared/helpers/queryParams";

type Props = {
  children: ReactNode;
  type: InvoiceType;
  links: BreadcrumbLink[];
  showLinkToDetail?: boolean;
  proformaInvoiceId?: string;
};

const InvoiceDetailLayoutPage = ({
  children,
  type,
  links,
  showLinkToDetail = true,
  proformaInvoiceId
}: Props) => {
  // translation
  const tModules = useTranslation("shared\\moduleNames").t;
  const tLabels = useTranslation("invoice\\invoice").t;

  // router
  const location = useLocation();

  // helpers
  const getLinks = (): BreadcrumbLink[] => {
    let result: BreadcrumbLink[] = [...links];

    if (showLinkToDetail) {
      result.push({
        text: tLabels(`invoiceDetailLayoutPage.${type}`),
        to: `detail${getProformaInvoiceIdParam()}`,
      });
    }

    result.push({ text: getTranslateByLocation() });

    return result;
  };

  const getTranslateByLocation = () => {
    if (location.pathname.endsWith("detail")) {
      return tLabels(`invoiceDetailLayoutPage.${type}`);
    } else if (location.pathname.endsWith("payments")) {
      return tLabels(`invoiceDetailLayoutPage.Payments`);
    }
  }

  const getProformaInvoiceIdParam = () => { 
    if (proformaInvoiceId) {
      const paramsStr = getQueryParams("proformaInvoiceId", proformaInvoiceId).toString();
      return `?${paramsStr}`;
    }
    return "";
  }

  // render
  return (
    <>
      <Header
        title={tModules("invoiceDetail.title")}
        includeBreadcrumbs
        titleAsBreadcrumbLink={false}
        links={getLinks()}
      />
      <ModuleContent>
        <TabsNavigation asModuleTabs>
          <NavTab to={`detail${getProformaInvoiceIdParam()}`}>
            {tLabels(`invoiceDetailLayoutPage.${type}`)}
          </NavTab>
          <NavTab to={`payments${getProformaInvoiceIdParam()}`}>
            {tLabels("invoiceDetailLayoutPage.Payments")}
          </NavTab>
        </TabsNavigation>
        {children}
      </ModuleContent>
    </>
  );
};

export default InvoiceDetailLayoutPage;
